import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoadingService } from './loading.service';
import { environment } from '@core/environments/environment';
import { Pagination } from '@core/models/pagination.model';
import { finalize, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReferralsService {
  http = inject(HttpClient);
  private loadingService = inject(LoadingService);

  BASE_URL = environment.ADMIN_BASE_URL + '/v1/admin';

  getReferralsWithCount(
    data?: Pagination,
    search_text?: string
  ): Observable<ReferralsListResponse> {
    const uniqueStateUrl = 'get-referrals';
    this.loadingService.setLoading(uniqueStateUrl, true);
    let url = '';

    if (search_text) {
      url = `${this.BASE_URL}/get-all-referrals-with-count?${search_text}`;
    } else {
      url = `${this.BASE_URL}/get-all-referrals-with-count?take=${data?.size}&skip=${data?.skip}`;
    }
  
    return this.http.get<ReferralsListResponse>(url).pipe(
      finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
    );
  }

  getReferralMetadata(): Observable<ReferralMetadataResponse> {
    const uniqueStateUrl = 'get-referral-metadata';
    this.loadingService.setLoading(uniqueStateUrl, true);
    const url = `${this.BASE_URL}/get-referral-metadata`;

    return this.http.get<ReferralMetadataResponse>(url).pipe(
      finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
    );

  }

 getReferredUsersByReferralCode(
  user_id: string, 
  referral_code: string, 
  skip: number = 0, 
  take: number = 10
): Observable<ReferredUsersResponse> {
  const uniqueStateUrl = 'get-referral-users-by-code';
  this.loadingService.setLoading(uniqueStateUrl, true);
  
  const url = `${this.BASE_URL}/referral-code-counts?user_id=${user_id}&referral_code=${referral_code}&skip=${skip}&take=${take}`;
  
  return this.http.get<ReferredUsersResponse>(url).pipe(
    finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
  );
}

getReferredUsersByReferralCodeWithFilter(
  user_id: string, 
  referral_code: string, 
  filterQuery: string
): Observable<ReferredUsersResponse> {
  const uniqueStateUrl = 'get-referral-users-by-code-filtered';
  this.loadingService.setLoading(uniqueStateUrl, true);
  
  const url = `${this.BASE_URL}/referral-code-counts?user_id=${user_id}&referral_code=${referral_code}&${filterQuery}`;
  
  return this.http.get<ReferredUsersResponse>(url).pipe(
    finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
  );
}
}

interface ReferralsListResponse {
  status: string;
  message: string;
  data: {
    data: ReferralsListData[];
    total_count: number;
  };
}

interface ReferralsListData {
  profile_name: string;
  referral_code: string;
  count: number;
  qualified_referrers_count: number;
  user_id: string
}

interface ReferralMetadataResponse {
  status: string;
  message: string;
  data: ReferralMetadata
}


export interface ReferralMetadata {
  referral_count: number;
  referral_count_with_topup: number;
}


export interface ReferredUsersResponse {
  status: string;
  message: string;
  data: {
    referred_user_names: referredNames[];
    total_count?: number;
  };
}
export interface referredNames {
  name: string;
  created_at: string;
}

export interface ReferredUser {
  user_id: string;
  name: string;
  referral_code: string;
}

